import React from 'react';

const Error: React.FC = () => {
  return (
    <div>
      {/* Error page content will go here */}
    </div>
  );
};

export default Error; 